<template>
<v-container fluid>
<v-layout wrap>
    <v-flex xs6 style="max-width:100%">
        <v-card class="elevation-1 ma-2">
            <v-toolbar flat dark color="green" >
                <v-toolbar-title><v-icon>mdi-file-excel</v-icon>Export des arbres</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>mdi-download</v-icon>
            </v-toolbar>
            <v-container fluid grid-list-xl >
            <v-layout align-center wrap >
                <v-flex xs12>

                </v-flex>
                <v-flex xs12>
                    <!-- <AutocompleteMulti v-if="!loading.getField"
                    :title="'Champs'"
                    :listParent.sync="fields" :listObject.sync="selectedFields"
                    :fields="{ 
                        index: 'ctp_id', text:'lra_source_id,ctp_label', autofocus: false,
                        search:'ctp_label', preprendIcon:'mdi-hammer-screwdriver', multiSelect:true, params:'' 
                    }"></AutocompleteMulti> -->
                </v-flex>
            </v-layout>
            </v-container>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn rounded color="success" :disabled="loading.getItem" @click="downloadReport('trees', { cdd_ctp_id: selectedFields })">
                    <v-icon left dark>mdi-content-save</v-icon>
                    <span class="hidden-sm-and-down">Telecharger</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
    <v-flex xs6 style="max-width:100%">
        <v-card class="elevation-1 ma-2">
            <v-toolbar flat dark color="primary" >
                <v-toolbar-title><v-icon>mdi-file-excel</v-icon>Export shape</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>mdi-download</v-icon>
            </v-toolbar>
            <v-container fluid grid-list-xl >
            <v-layout align-center wrap >
                <v-flex xs12>
                    <AutocompleteMulti v-if="!loading.getField"
                    :title="'Champs'"
                    :listParent.sync="fields" :listObject.sync="selectedFields"
                    :fields="{ 
                        index: 'ctp_id', text:'ctp_label', autofocus: false,
                        search:'ctp_label', preprendIcon:'mdi-hammer-screwdriver', multiSelect:true, params:'' 
                    }"></AutocompleteMulti>
                </v-flex>
                <v-flex xs12>
                    <v-checkbox v-model="exportLayer" label="Exporter les dessins" @click="getVersionLabel"></v-checkbox>
                </v-flex>
            </v-layout>
            </v-container>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn rounded color="success" :disabled="loading.getItem" @click="downloadReport('trees/shape', { cdd_ctp_id: selectedFields, polygon: exportLayer })">
                    <v-icon left dark>mdi-content-save</v-icon>
                    <span class="hidden-sm-and-down">Telecharger</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
    <v-flex xs6 style="max-width:100%">
        <v-card class="elevation-1 ma-2">
            <v-toolbar flat dark color="orange" >
                <v-toolbar-title><v-icon>mdi-timer</v-icon>Export des temps de travail</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>mdi-download</v-icon>
            </v-toolbar>
            <v-container fluid grid-list-xl >
            <v-layout align-center wrap >
                <v-flex xs12>
                    <v-select v-model="wtOptions.lra_id" :items="layerItems" item-text="lra_source_id" item-value="lra_id"
                        label="Layer" prepend-icon="mdi-layers" clearable dense outlined hide-details
                    ></v-select>
                </v-flex>
                <v-flex xs12>
                    <v-select v-model="wtOptions.group_by" :items="wtGroupOptions"
                        label="Regroupement" prepend-icon="mdi-group" clearable dense outlined hide-details
                    ></v-select>
                </v-flex>
                <v-flex xs12>
                    <v-select v-model="wtOptions.wti_typ_id" :items="wtTypeOptions"
                        label="Type de temps" prepend-icon="mdi-clock-outline" clearable dense outlined hide-details
                    ></v-select>
                </v-flex>
                <v-flex xs6>
                    <v-menu v-model="wtDateMenu.start" :close-on-content-click="false" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-bind="attrs" v-on="on" readonly clearable dense outlined hide-details
                                :value="(wtOptions.date_start) ? $date(wtOptions.date_start).format('DD/MM/YYYY') : ''"
                                label="Date début" prepend-icon="mdi-calendar-today"
                                @click:clear="wtOptions.date_start = null"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="wtOptions.date_start" locale="fr-fr" no-title scrollable first-day-of-week="1" @input="wtDateMenu.start = false"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-flex xs6>
                    <v-menu v-model="wtDateMenu.end" :close-on-content-click="false" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-bind="attrs" v-on="on" readonly clearable dense outlined hide-details
                                :value="(wtOptions.date_end) ? $date(wtOptions.date_end).format('DD/MM/YYYY') : ''"
                                label="Date fin" prepend-icon="mdi-calendar-today"
                                @click:clear="wtOptions.date_end = null"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="wtOptions.date_end" locale="fr-fr" no-title scrollable first-day-of-week="1" @input="wtDateMenu.end = false"></v-date-picker>
                    </v-menu>
                </v-flex>
            </v-layout>
            </v-container>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn rounded color="success" :disabled="loading.getItem" @click="downloadWorktimes">
                    <v-icon left dark>mdi-content-save</v-icon>
                    <span class="hidden-sm-and-down">Telecharger</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
    <v-flex xs6 style="max-width:100%">
        <v-card class="elevation-1 ma-2">
            <v-toolbar flat dark color="deep-purple" >
                <v-toolbar-title><v-icon>mdi-robot-outline</v-icon>Export IA (question libre)</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon>mdi-download</v-icon>
            </v-toolbar>
            <v-container fluid grid-list-xl >
            <v-layout align-center wrap >
                <v-flex xs12>
                    <v-text-field v-model="aiQuestion" label="Votre question"
                        placeholder="Ex : les 30 derniers arbres avec id, projet et date"
                        prepend-icon="mdi-chat-question-outline" clearable dense outlined hide-details
                        :loading="loading.ai" @keyup.enter="askAi">
                    </v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-checkbox v-model="aiFormatNone" label="Réponse texte seulement (sans fichier)" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="aiAnswerHtml">
                    <v-card outlined class="pa-3">
                        <div class="markdown-body ai-markdown" v-html="aiAnswerHtml"></div>
                    </v-card>
                </v-flex>
            </v-layout>
            </v-container>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn rounded color="success" :loading="loading.ai" @click="askAi">
                    <v-icon left dark>mdi-content-save</v-icon>
                    <span class="hidden-sm-and-down">Telecharger</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
</v-layout>
</v-container>
</template>

<script>
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'
import { mapState } from 'pinia'
import { useTypeStore } from '@/stores/type'
import { useProjectVersionStore } from '@/stores/projectVersion'
import { useCacheStore } from '@/stores/cache'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import 'github-markdown-css/github-markdown-light.css'

export default {
    name: 'report-page',
    components: { AutocompleteMulti },
    props: [], 
    data: function () {
        return {
            loading: { getItem: false, getField: true, ai: false },
            aiQuestion: '',
            aiFormatNone: false,
            aiAnswerHtml: '',
            dateMenu: { 
                date_byevent   : null,
            },
            dateReport : {
                date_byevent   : null,
            },
            items  : [],
            select : [],
            fields : [],
            selectedFields : [],
            exportLayer : false,
            wtDateMenu : { start: false, end: false },
            wtOptions : {
                date_start : null,
                date_end   : null,
                group_by   : 'tasktype',
                wti_typ_id : null,
                lra_id     : null,
            },
            layerItems : [],
            wtGroupOptions : [
                { text: 'Par type de tâche', value: 'tasktype' },
                { text: 'Par utilisateur', value: 'user' },
                { text: 'Par type de tâche et utilisateur', value: 'tasktype,user' },
            ],
            wtTypeOptions : [
                { text: 'Travail', value: 'WTI01' },
                { text: 'Transport', value: 'WTI02' },
            ],
        }
    },
    computed: {
        ...mapState(useProjectVersionStore, {version: 'itemList'}),
        state(){
            const typeStore = useTypeStore()
            return typeStore.getTypesByTag('EVE', 'PRO')
        },
    },
    mounted:function (){
        this.getVersionLabel()
        this.getLayerItems()
    },
    methods: {
        getEquipmentFilter(){
            const cacheStore = useCacheStore()
            let filter = cacheStore.getFilter
            let searchCriteria = '?per_page=false&extended=true'
            for( var prop in filter ){
                if( filter[prop] !== null && filter[prop] !== undefined && filter[prop].length > 0 ){
                    searchCriteria += '&' + prop + '=' + filter[prop]
                }
            }
            return searchCriteria
        },
        downloadReport(report, option){
            this.loading.getItem = true
            let searchCriteria = this.getEquipmentFilter()
            for(let prop in option){
                if( option[prop] !== null && option[prop] !== undefined ){
                    searchCriteria += '&' + prop + '=' + option[prop]
                }
            }
            this.$http.customRequest({ method: 'get', url: '/report/' + report + '/' + searchCriteria, responseType: 'blob' } )
            .then( (response) => {
                let filename = "";
                let disposition = response?.headers['content-disposition'];
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) { 
                        filename = matches[1].replace(/['"]/g, '');
                    }
                } else {
                    filename = 'rapport.xlsx'
                }
                this.$download(response.data, filename, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                this.loading.getItem = false
            }).catch( (error) => {
                this.$root.$toast({ text: 'Erreur lors de l\'extraction !', error: error })
                this.loading.getItem = false
            })
        },
        downloadWorktimes(){
            this.loading.getItem = true
            let params = []
            if( this.wtOptions.lra_id ){ params.push('lra_id=' + this.wtOptions.lra_id) }
            if( this.wtOptions.date_start ){ params.push('date_start=' + this.wtOptions.date_start) }
            if( this.wtOptions.date_end ){ params.push('date_end=' + this.wtOptions.date_end) }
            if( this.wtOptions.group_by ){ params.push('group_by=' + this.wtOptions.group_by) }
            if( this.wtOptions.wti_typ_id ){ params.push('wti_typ_id=' + this.wtOptions.wti_typ_id) }
            let query = (params.length) ? '?' + params.join('&') : ''
            this.$http.customRequest({ method: 'get', url: '/report/worktimes' + query, responseType: 'blob' } )
            .then( (response) => {
                this.$download(response.data, "temps_de_travail.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                this.loading.getItem = false
            }).catch( (error) => {
                this.$root.$toast({ text: 'Erreur lors de l\'extraction !', error: error })
                this.loading.getItem = false
            })
        },
        /**
         * Pose une question libre à l'IA (workflow n8n CityTree-ask-sql via l'API Laravel).
         * Récupère la réponse texte et éventuellement un fichier XLSX en base64.
         */
        async askAi(){
            if( !this.aiQuestion || this.aiQuestion.trim().length < 2 || this.loading.ai ){
                return
            }
            this.loading.ai = true
            this.aiAnswerHtml = ''
            try {
                let response = await this.$http.post( '/ai/ask', {
                    question: this.aiQuestion,
                    format: (this.aiFormatNone) ? 'none' : 'xlsx'
                })
                let data = response.data?.data || {}
                // Conversion markdown -> HTML (sanitisé) pour l'affichage
                this.aiAnswerHtml = DOMPurify.sanitize( marked.parse( data.answer || '' ) )
                // Ne télécharge le fichier que si demandé (format xlsx) et présent dans la réponse
                if( !this.aiFormatNone && data.file_base64 && data.filename ){
                    this.downloadBase64( data.file_base64, data.filename, data.mime_type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' )
                    this.$root.$toast({ color: 'success', text: 'Fichier ' + data.filename + ' téléchargé' })
                }
            } catch( error ){
                let msg = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error
                this.$root.$toast({ color: 'error', text: 'Erreur IA : ' + msg })
            }
            this.loading.ai = false
        },
        /**
         * Télécharge un fichier depuis une chaine base64.
         */
        downloadBase64( base64, filename, mimeType ){
            let byteCharacters = atob( base64 )
            let byteNumbers = new Array( byteCharacters.length )
            for( let i = 0; i < byteCharacters.length; i++ ){
                byteNumbers[i] = byteCharacters.charCodeAt( i )
            }
            let byteArray = new Uint8Array( byteNumbers )
            let blob = new Blob( [byteArray], { type: mimeType } )
            this.$download( blob, filename, mimeType )
        },
        async getVersionLabel(){
            this.loading.getField = true
            
            let version = (this.exportLayer) ? this.version.find(obj => obj.prv_typ_id === 'VER02') : this.version.find(obj => obj.prv_typ_id === 'VER04')
            if( version ){
                this.$http.get( '/layersassoc/?per_page=9999&lra_prv_id=' + version.prv_id + '&extended=withtemplate' ).then( (response) => {
                    if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                        this.fields = response.data.data
                    }
                    this.loading.getField = false
                })
            }
        },
        /**
         * Charge la liste des layers (f_layer_assoc) du projet pour le filtre de l'export des temps.
         */
        getLayerItems(){
            this.$http.get( '/layersassoc/?per_page=false&order_by=lra_source_id&order_direction=asc' ).then( (response) => {
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.layerItems = response.data.data
                }
            })
        },
        downloadSite(){
            this.loading.getItem = true
            let searchCriteria = this.getEquipmentFilter()
            this.$http.customRequest({ method: 'get', url: '/report/tree/' + searchCriteria, responseType: 'blob' } )
            .then( (response) => {
                this.$download(response.data, "rapport.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                this.loading.getItem = false
            }).catch( (error) => {
                this.$root.$toast({ text: 'Erreur lors de l\'extraction !', error: error })
                this.loading.getItem = false
            })
        },
    }
}
</script>

<style lang="scss">
.ai-markdown {
    font-size: 14px;
    background-color: white !important;
    // Les tables générées par le markdown ne débordent pas de la carte
    table {
        display: table;
        width: 100%;
    }
}
</style>